module.exports = __webpack_public_path__ + "img/talk-img2.6f0e6785.png";